function createEventBus() {
	const listeners = {}
	const registeredEvents = new Set()

	function registerEvent(eventName) {
		registeredEvents.add(eventName)
	}

	function $on(eventName, callback) {
		if (!registeredEvents.has(eventName)) {
			console.error(`Event "${eventName}" is not registered.`)
			return
		}

		if (!listeners[eventName]) {
			listeners[eventName] = []
		}
		listeners[eventName].push(callback)
	}

	function $emit(eventName, data) {
		if (!registeredEvents.has(eventName)) {
			console.error(`Event "${eventName}" is not registered.`)
			return
		}

		if (listeners[eventName]) {
			listeners[eventName].forEach((callback) => {
				callback(data)
			})
		}
	}

	function unsubscribe(eventName, callback) {
		if (listeners[eventName]) {
			listeners[eventName] = listeners[eventName].filter((listener) => listener !== callback)
		}
	}

	return {
		registerEvent,
		$on,
		$emit,
		unsubscribe
	}
}

const EventBus = createEventBus()

// 注册事件名称
EventBus.registerEvent('afterPopUpLogin')
EventBus.registerEvent('afterTokenInvalid')
EventBus.registerEvent('changeLan')

export default EventBus
